import React, { useRef, useCallback } from 'react'
import { Modal } from 'antd'
// import { isFormDataRequired } from 'src/lib/utils/collections'
import { DefaultJsonForm } from 'src/react-app/components/default-json-form'

const selectedSchema = {
  type: 'object',
  required: ['content'],
  properties: {
    "content": {
      "type": "string",
      "title": "Причина завершения",
      "options": {
        "type": "textarea"
      },
    },
  },
}

export function modalOpen( ) {
  let formData = { content: '' }
  return new Promise(resolve => {
    Modal.confirm({
      icon: null,
      title: 'Завершение задачи',
      content: <Content onChange={value => {
        formData = value
      }} schema={selectedSchema} />,
      onOk: () => new Promise((ok, err) => {
        const isRequired = formData?.['content']
        if(isRequired){
          resolve(formData)
          ok(null)
        }
        err()
      }),
      onCancel(){
        resolve(null)
      }
    })
  })
}

function Content({ onChange, schema }){
  const formDataRef =  useRef({})
  const localOnChange = useCallback(({ formData }) => {
    formDataRef.current = formData
    onChange(formData)
  }, [onChange])

  return (
    <DefaultJsonForm
      formData={formDataRef.current}
      schema={schema}
      onChange={localOnChange}
    />
  )
}